import React from 'react';

import  AuthorsTalk2025  from 'views/AuthorsTalk2025';
const BlogNewsroomPage = () => {

return <AuthorsTalk2025/>
};

export default BlogNewsroomPage;